export default function References(props) {

  const handleBackToReferenceClick = (e) => { 
    e.preventDefault();
    let link = e.target.parentElement.getAttribute('href').substr(1);

    window.scrollBy({
      top: document.getElementById(link).getBoundingClientRect().top - (document.querySelector(".App-header").getBoundingClientRect().height * 1.5),
      behavior: "smooth"
    });

  }

  //console.log(props.references);
  return (
    <>

    <section id="references" className="usps-article-references usps-article-references--collapsed">
      <h6 className="screen-reader-text" id="references__label">Footnotes</h6>

      <ol className='cm-references'>

      {props.references.map((reference, i) => {
        i = i+1;
        return (

          <li className='cm-references__reference' id={'reference-' + i} tabIndex="0"><span className="cm-references__reference-index">[{i}]</span> <span dangerouslySetInnerHTML={{ __html: reference.reference }}/>

              <a className='cm-references__return' onClick={(e) =>  handleBackToReferenceClick(e)} href={'#s' + i} tabIndex='0' aria-label="Back to Content">
                  <i className="cm-icon material-icons" aria-hidden="true">arrow_right_alt</i>
                </a>
            </li>

          );

      })}
   
      </ol>

      <p className='takeaway-disclaimer'>QR Code is a registered trademark of DENSO WAVE INCORPORATED.</p>

      </section> 

    </>
  );

}
